export default __webpack_public_path__ + "static/media/office_building.2b721c0a.svg";